import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.937 11.55a1.503 1.503 0 002.12 0l6.566-6.566A2.975 2.975 0 0018 4.5H6c-.6 0-1.157.181-1.626.486l6.563 6.563z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.118 12.61a2.994 2.994 0 01-2.121.877 2.992 2.992 0 01-2.121-.877L3.364 6.098A2.96 2.96 0 003 7.5v9c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3v-9c0-.511-.14-.984-.366-1.406l-6.516 6.516z",
    clipRule: "evenodd"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.937 11.55a1.503 1.503 0 002.12 0l6.566-6.566A2.975 2.975 0 0018 4.5H6c-.6 0-1.157.181-1.626.486l6.563 6.563z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.118 12.61a2.994 2.994 0 01-2.121.877 2.992 2.992 0 01-2.121-.877L3.364 6.098A2.96 2.96 0 003 7.5v9c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3v-9c0-.511-.14-.984-.366-1.406l-6.516 6.516z",
    clipRule: "evenodd"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.873 23.099a3.006 3.006 0 004.242 0l13.132-13.13A5.95 5.95 0 0036 9H12c-1.2 0-2.314.362-3.252.972l13.126 13.126z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M28.236 25.22a5.988 5.988 0 01-4.242 1.754 5.984 5.984 0 01-4.241-1.754L6.728 12.196C6.278 13.038 6 13.982 6 15v18c0 3.308 2.692 6 6 6h24c3.309 0 6-2.692 6-6V15c0-1.022-.28-1.968-.731-2.812L28.237 25.22z",
    clipRule: "evenodd"
  }))
};
export var InboxFilled = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});